import { Button } from '@accure/ui';
import { RotateCw } from 'lucide-react';

import { CommunicationSync } from '@/api/fe-api/view/mutations/communication-sync';
import { cls } from '@/utils/cls';

export function CommunicationSidebarRefresh() {
  const communicationSync = CommunicationSync.useMutation();

  function handleClick() {
    communicationSync.mutate({});
  }

  return (
    <Button
      onClick={handleClick}
      disabled={communicationSync.isLoading}
      variant="ghost"
      size="icon"
      className={cls(
        'rounded-full hover:bg-gray-100',
        communicationSync.isLoading ? 'text-gray-500' : 'text-gray-600',
      )}
      aria-label="Refresh communications"
    >
      <RotateCw
        className={cls('h-5 w-5', {
          'animate-spin': communicationSync.isLoading,
        })}
      />
    </Button>
  );
}
